<template>
  <div class="standard-normal-font-size body-content-container" data-radium="true">
    <main class="container-fluid" style="">
      <section class="carouselSliderSection">
        <swiper v-bind="swiperOptions">
          <swiper-slide>
            <div>
              <img src="/static/img/banner/banner20230217150457325.png" class="home_banner" alt="banner"
                id="home-banner-0" style="height: 100%; cursor: pointer;" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <img src="/static/img/banner/banner20230106053938048.png" class="home_banner" alt="banner"
                id="home-banner-1" style="height: 100%; cursor: pointer;" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <img src="/static/img/banner/banner20230528032058085.png" class="home_banner" alt="banner"
                id="home-banner-2" style="height: 100%; cursor: pointer;" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <img src="/static/img/banner/banner20220921102813567.png" class="home_banner" alt="banner"
                id="home-banner-3" style="height: 100%; cursor: pointer;" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div>
              <img src="/static/img/banner/banner20230519031252925.png" class="home_banner" alt="banner"
                id="home-banner-4" style="height: 100%; cursor: pointer;" />
            </div>
          </swiper-slide>
        </swiper>
      </section>
      <article class="articleContainer">
        <div class="contentWarrperInner">
          <section class="hotgameSection">
            <div class="hotGameContainer">
              <header>
                <div class="container gx-0">
                  <div class="row g-0 gx-0" style="padding:5px;">
                    <div class="col">
                      <p><span>โปรโมชั่น</span></p>
                    </div>
                  </div>
                </div>

              </header>
              <div class="container gx-0">
                <div class="slick-slider slick-initialized " dir="ltr" style="padding-left:15px;">
                  <div class="slick-list">
                    <VueSlickCarousel v-bind="slickSetting">
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/1.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>แนะนำมาเล่นเว็บเรา รับ 25%</p>
                              <div class="hotGameSubContent">
                                <span>ไม่อั้น รับเต็มๆ จากยอดฝาก</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/2.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 1 รับ 100 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 250 ถอนได้ 100 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/3.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 5 รับ 200 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 350 ถอนได้ 200 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/4.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 10 รับ 250 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 400 ถอนได้ 250 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/5.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 20 รับ 300 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 500 ถอนได้ 300 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/6.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 30 รับ 450 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 750 ถอนได้ 450 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/7.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 50 รับ 600 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 900 ถอนได้ 600 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/8.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 70 รับ 800 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 1300 ถอนได้ 800 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-index="0" class="slick-slide" tabindex="-1" aria-hidden="true"
                        style="outline: none; width: 187px;">
                        <div>
                          <div class="hotGameSlider" tabindex="-1" style="width: 100%; display: inline-block;">
                            <img src="/static/img/landing/pro/9.jpg" alt="s5ForStar" />
                            <div class="hotGameRoundBtn">

                            </div>
                            <div class="hotgameContent">
                              <p>ฝาก 90 รับ 1000 บาท</p>
                              <div class="hotGameSubContent">
                                <span>เทิร์นโอเวอร์ 1600 ถอนได้ 1000 บาท</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </VueSlickCarousel>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="slotsLandingSection ">
            <div class="homeProviderLandingIndexContainer container gx-0">
              <div class="mid  s8-provider-landing-icon-template">
              </div>
              <div class="bottom  s8-provider-landing-icon-template">
                <div class="standard-tab-container tab-container mb-1">
                  <div class="standard-tab">
                    <div class="tab-list">
                      <div class="tab-header active">
                        HOT
                        <div class="hover-line"></div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class=" row g-0 gx-0">
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sCandyBona.png" /></span>
                        <div class="title-box">
                          <div>Oishi Delights</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sDiamond7.png" /></span>
                        <div class="title-box">
                          <div>Three Crazy Piggies</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sGolWest.png" /></span>
                        <div class="title-box">
                          <div>Wings of Iguazu</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sHotSmash.jpg" /></span>
                        <div class="title-box">
                          <div>Yakuza Honor</div>
                        </div>
                      </div>
                    </div>
                  </div>
                                    <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sBuffK.png" /></span>
                        <div class="title-box">
                          <div>Shark Hunter</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sGoldenWar11.jpg" /></span>
                        <div class="title-box">
                          <div>Futebol Fever</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sRomaII11.jpg" /></span>
                        <div class="title-box">
                          <div>Chicky Run</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sGoldenWar.jpg" /></span>
                        <div class="title-box">
                          <div>Zombie Outbreak</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sRoma11.png" /></span>
                        <div class="title-box">
                          <div>Anubis Wrath</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sSweetLava.png" /></span>
                        <div class="title-box">
                          <div>Mystic Potion</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sClaFruit7.png" /></span>
                        <div class="title-box">
                          <div>Pinata Wins</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sCaiShen.jpg" /></span>
                        <div class="title-box">
                          <div>Wild Ape #3258</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sForToad.png" /></span>
                        <div class="title-box">
                          <div>Cash Mania</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sHotSmash.png" /></span>
                        <div class="title-box">
                          <div>Gemstones Gold</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sGoldenFa.png" /></span>
                        <div class="title-box">
                          <div>Fortune Dragon</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/s7Dragons.png" /></span>
                        <div class="title-box">
                          <div>Dragon Hatch 2</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/s5ForStar.png" /></span>
                        <div class="title-box">
                          <div>Werewolf's Hunt</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-col slot-game-item-container col">
                    <div class="item-container">
                      <div class="item">
                        <span class=" lazy-load-image-background opacity lazy-load-image-loaded"
                          style="color: transparent; display: inline-block;"><img class="item-img"
                            src="/static/img/landing/sHighwayB.png" /></span>
                        <div class="title-box">
                          <div>Tsar Treasures</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="liveCasinoSection">
            <div class="liveCasinoSliderContainer container gx-0">
              <header>
                <div class="headerLeft">
                  <img src="/static/img/landing/casino.png" alt="" />
                  <p>คาสิโนสด</p>
                </div>
              </header>
              <ul class="liveSlider">
                <div class="slick-slider slick-initialized" dir="ltr">
                  <div class="slick-prev-btn" style="display: block;">
                    <svg width="100%" height="100%" class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path fill="" d="M320 128L192 256l128 128z"></path>
                    </svg>
                  </div>
                  <swiper v-bind="swiperGameOptions">
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-allbet.jpg" alt="8" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Allbet</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-ebet.jpg" alt="10" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Ebet</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-wm.jpg" alt="11" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>WM Casino</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-bg.jpg" alt="10" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Big Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-ae.jpg" alt="11" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Sexy Baccarat</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-ag.jpg" alt="2" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Asia Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-dg.jpg" alt="9" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Dream Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-mg.jpg" alt="1" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Microgaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-evo.jpg" alt="3" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Evolution Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-gp.jpg" alt="5" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Gameplay</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-pt.jpg" alt="6" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Playtech</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-sa.jpg" alt="7" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>SA Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-allbet.jpg" alt="8" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Allbet</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-ebet.jpg" alt="10" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Ebet</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-wm.jpg" alt="11" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>WM Casino</p>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="liveGameSlider">
                        <div class="sliderImgWarper">
                          <img src="/static/img/landing/home-casino-bg.jpg" alt="10" />
                        </div>
                        <div class="liveGameRoundBtn">
                          <button aria-label="launch-game" class="liveGamePlayBtn">
                            <svg width="1em" height="1em" class="" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <path
                                d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <div class="liveGameContent">
                          <p>Big Gaming</p>
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="slick-next-btn" style="display: block;">
                    <svg width="100%" height="100%" class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path fill="" d="M192 128l128 128-128 128z"></path>
                    </svg>
                  </div>
                </div>
              </ul>
            </div>
          </section>
          <section class="promoLiveSection">
            <div class="promoLiveContainer container gx-0">

            </div>
          </section>

        </div>
      </article>
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);
// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import api from "@/services/index.js";
import MarqueeText from "vue-marquee-text-component";

export default {
  name: "Index",

  data() {
    return {
      slickSetting: {
        "dots": true,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 5.5,
        "slidesToScroll": 5.5,
        "initialSlide": 0,
        "responsive": [
          {
            "breakpoint": 1920,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1680,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1280,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1152,
            "settings": {
              "slidesToShow": 4.5,
              "slidesToScroll": 4.5,
            }
          },
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 4,
              "slidesToScroll": 4,
            }
          },
          {
            "breakpoint": 832,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1.5,
              "slidesToScroll": 1.5,
            }
          },
          {
            "breakpoint": 320,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      },
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: false,
        slidesPerView: "auto",
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
      swiperGameOptions: {
        loop: false,
        slidesPerView: 4,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: false,
        spaceBetween: 0,
        // navigation: false,
        navigation: {
          nextEl: ".slick-prev-btn",
          prevEl: ".slick-next-btn",
        },
      },
      swiperPromotionOptions: {
        loop: false,
        slidesPerView: "auto",
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
      swiperWinnerOptions: {
        loop: false,
        slidesPerView: "auto",
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
        pagination: {
          el: ".winner-active-page",
          type: "fraction",
        },
      },
      swiperTopOptions: {
        loop: false,
        slidesPerView: "auto",
        // navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
        navigation: {
          nextEl: ".provider-next-btn",
          prevEl: ".provider-prev-btn",
        },
      },
      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },

  components: {
    Header,
    Swiper,
    SwiperSlide,
    VueSlickCarousel,
    Footer,
    MarqueeText,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => { });
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire(v.message, "", "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire(e.message, "", "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire(v.message, "", "error");
            }
          })
          .catch((e) => {
            this.$swal.fire(e.message, "", "error");
          })
          .finally(() => { });
      }, 3000);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire(v.message, "", "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire(e.message, "", "error");
            }
          })
          .finally(() => { });
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => { });
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire(v.message, "", "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire(e.message, "", "error");
            }
          })
          .finally(() => { });
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },
  },
  async mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/views/Index.vue